import React from "react";

const LkMenuMobileNav = (props) => {
    return(
        <div className="p-[20px] pt-[70px] overflow-y-auto hide-scrollbar text-[14px]">

            <div className="py-[12px] rounded-[24px] transition-opacity duration-300"
            style={{ background: props.data.MenuColors.white }}>
                {props.data.LkMenu.map((item, index) => (
                    <div key={index}>
                        <a href={item.link}
                            className={`flex items-center gap-[12px] px-[20px] py-[12px] ${props.activeMenu === index ? 'border-solid border-l-[4px]' : ''}`}
                            style={{borderColor: props.data.MenuColors.red}}
                            onClick={() => props.setActiveMenu(index)}
                        >
                            <img src={props.activeMenu === index ? item.imgHover : item.img} />
                            <span className={`transition-opacity duration-300 `}>{item.title}</span>
                        </a>
                    </div>
                ))}
            </div>

            <a href="/calculator" className="mt-[20px] cursor-pointer w-[100%] py-[20px] flex flex-col items-center gap-[10px] bg-[#fff] rounded-[24px] border-dashed border-[1px]"
            style={{borderColor: props.data.MenuNewApp.borderColor}}>
                <div>
                    <img src={props.data.MenuNewApp.image} />
                </div>
                <div className={`transition-opacity duration-300`}>
                    {props.data.MenuNewApp.text}
                </div>
            </a>
        </div>
    )
}

export default LkMenuMobileNav;
